import { render, staticRenderFns } from "./MyProjectsInvoices.vue?vue&type=template&id=f2e43452"
import script from "./MyProjectsInvoices.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsInvoices.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports